module.exports = __webpack_public_path__ + "static/media/LandingPage-Box-InativaMedalha-h-06.6577cae4.png";